var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreenIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 2,
    height: 6,
    rx: 1,
    strokeWidth: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 16,
    height: 2,
    rx: 1,
    strokeWidth: 1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 5.79086 2.79086 4 5 4H27C29.2091 4 31 5.79086 31 8V22C31 24.2091 29.2091 26 27 26H5C2.79086 26 1 24.2091 1 22V8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4801 20.7969C16.215 21.0677 15.785 21.0677 15.5199 20.7969L11.1989 16.3846C10.9337 16.1138 10.9337 15.6748 11.1989 15.4041C11.464 15.1333 11.8939 15.1333 12.1591 15.4041L15.321 18.6328L15.321 8.69333C15.321 8.31042 15.625 8 16 8C16.375 8 16.679 8.31042 16.679 8.69333L16.679 18.6328L19.8409 15.4041C20.1061 15.1333 20.536 15.1333 20.8011 15.4041C21.0663 15.6748 21.0663 16.1138 20.8011 16.3846L16.4801 20.7969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenIn);
export default __webpack_public_path__ + "static/media/share-screen-in.0377dae8b7871c33f5bc4b72f8cab7fa.svg";
export { ForwardRef as ReactComponent };